<template>
  <div>
    <i-select
      class="products-select"
      :loading="loading"
      :filterable="true"
      allow-create
      :clearable="true"
      :value="value"
      @on-clear="on_clear"
      @on-select="on_select"
      @on-create="on_create"
    >
      <i-option v-for="item in list" :key="item.name" :label="item.name" :value="item.name" />
    </i-select>
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      list: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      on_select(value) {
        this.$emit('handle_select', value);
      },
      on_create(value) {
        this.$emit('handle_create', value);
      },
      on_clear() {
        this.$emit('handle_clear');
      }
    }
  };
</script>

<style>
  .products-select .ivu-select-dropdown {
    width: 300px;
  }
</style>
